import api from './api';

export function heartbeat() {
  return api.post('/api/v2/heartbeats', {
    longitude: 0,
    latitude: 0,
    accuracy: 0,
  });
}

export function readHeartbeat(username) {
  return api.get(`/api/v2/heartbeats/${username}`);
}
